import { render } from "./CoachMembersView.vue?vue&type=template&id=b3333e10&scoped=true"
import script from "./CoachMembersView.vue?vue&type=script&lang=js"
export * from "./CoachMembersView.vue?vue&type=script&lang=js"

import "./CoachMembersView.vue?vue&type=style&index=0&id=b3333e10&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3333e10"]])

export default __exports__